import { render, staticRenderFns } from "./CardListC2P.vue?vue&type=template&id=45250afe&scoped=true"
import script from "./CardListC2P.vue?vue&type=script&lang=js"
export * from "./CardListC2P.vue?vue&type=script&lang=js"
import style0 from "./CardListC2P.vue?vue&type=style&index=0&id=45250afe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45250afe",
  null
  
)

export default component.exports